<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const isEnabled = ref(false);
const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    isEnabled.value =
      !!currentAccount.value?.settings?.autoload_conversation_history;
  },
  { deep: true, immediate: true }
);

const toggleAutoloadHistory = async () => {
  try {
    await updateAccount({ autoload_conversation_history: isEnabled.value });
    useAlert(t('GENERAL_SETTINGS.FORM.AUTOLOAD_CONVERSATION_HISTORY.SUCCESS'));
  } catch (error) {
    isEnabled.value = !isEnabled.value;
    useAlert(t('GENERAL_SETTINGS.FORM.AUTOLOAD_CONVERSATION_HISTORY.ERROR'));
  }
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.AUTOLOAD_CONVERSATION_HISTORY.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.AUTOLOAD_CONVERSATION_HISTORY.NOTE')"
    with-border
  >
    <template #headerActions>
      <Switch v-model="isEnabled" @change="toggleAutoloadHistory" />
    </template>
  </SectionLayout>
</template>
